import React from "react";
import { Autocomplete } from "@material-ui/lab";
import { CircularProgress, TextField } from "@material-ui/core";
import { debounce } from "lodash-es";
import { reqSuppliers } from "./api";

// 참고) https://v4.mui.com/components/autocomplete/#asynchronous-requests 
const SupplierSearch = ({ onChange }) => {

  const [ open, setOpen ] = React.useState(false);
  const [ options, setOptions ] = React.useState([]);
  const dataRef = React.useRef({
    loading: false,
    keyword: ''
  });

  // clear options 
  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [ open ]);
  
  const updateOptions = async (keyword) => {

    const k = keyword.trim();
    if (dataRef.current.keyword !== k && k.length !== 0) {
      // TODO cancel prev fetching 
      dataRef.current.keyword = k;
      try {
        // fetch 
        dataRef.current.loading = true;
        const result = await reqSuppliers(k);
        dataRef.current.loading = false;
        setOptions(result.data);
      } catch (err) {
        console.error(err)
        // TODO toast msg 

      }
    }
  }

  const debouncedUpdateOptions = React.useMemo(
    () => debounce(updateOptions, 300)
  , []);

  const handleInputChange = (evt, value, reason) => {

    if ('input' === reason) {
      debouncedUpdateOptions(value);
    }
    else {  // 'reset', 'select-option'
      // clear options 

    }
  }

  const handleChange = (evt, value, reason) => {
    onChange(value);
  }

  return (
    <div>
      <Autocomplete
        //style
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        options={options}
        loading={open & dataRef.current.loading}
        onInputChange={handleInputChange}
        getOptionSelected={(option, value) => option.id === value.id}
        getOptionLabel={(option) => option.name}
        onChange={handleChange}
        renderInput={(params) => (
          <TextField
            {...params}
            label="공급사"
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {dataRef.current.loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />

    </div>    
  );
}

export default SupplierSearch;